import React from 'react'
import SubscribeForm from './SubscribeForm'

export default () => (
	<div className="subscription-wrap text-center">
		<h2 className="heading">Subscribe to our newsletter</h2>
		<div className="content">
			<p>
				Stay up to date! Get all the latest & greatest posts delivered straight
				to your inbox once in a month.
			</p>
		</div>
		<SubscribeForm
			formClass="subscription-form"
			inputClass="form-control"
			buttonClass="submit-btn btn btn-secondary"
			placeholder={`yourmail@example.com`}
		/>
	</div>
)
